export default "__VITE_ASSET__BfiQacNt__"